/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Secondsubjectgraduation2Inputs */

const de__field_secondsubjectgraduation2 = /** @type {(inputs: _Field_Secondsubjectgraduation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss Zweitfach`)
};

/**

* @param {_Field_Secondsubjectgraduation2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_secondsubjectgraduation2 = /** @type {((inputs?: _Field_Secondsubjectgraduation2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Secondsubjectgraduation2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_secondsubjectgraduation2(inputs)
});
export { _field_secondsubjectgraduation2 as "_field_secondSubjectGraduation" }